<template>
  <v-container>
    <v-row v-for="photo in photosMembers" :key="photo.id">
      <v-col cols="12" md="11">
        <v-img contain :src="photo.link"></v-img>
      </v-col>
      <v-col cols="12" md="1">{{photo.caption}}</v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "GroupContent",
  computed: mapState(["loadingPhotosMembers", "photosMembers"]),
  mounted() {
    if (!this.photosMembers.length) this.$store.dispatch("cargarPhotosMembers");
  }
};
</script>

<style scoped>
</style>